import React, { useEffect, useState } from "react";
import "./home.css";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useData } from "../contexts/datacontext";
import { Helmet } from "react-helmet";

export default function Projects() {

  const { projects } = useData();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    
    <div className="projects-main" style={isMobile ? {alignItems: "flex-start"} : {}}>
      <Helmet>
        <title>Projects</title>
      </Helmet>
      <div className="flex-col items-center">
          <div className="massive font-semibold">Personal projects</div>
      </div>
      {!isMobile ? (
        <div className="projectsRow">
          {projects.map((project) => (
            <Link to={`/project/${project.id}`} className="alternative" key={project.id}>
              <div className="projectImageWrapper">
                {project.overlay && (<div className="img-overlay">{project.overlay}</div>)}
                <img src={project.backgroundIMG} alt="b-img" className="projectCover" />
              </div>
              <div className="projectsScroll">
                <div className="projectInfo">
                  <div className="project-title">{project.title_short}</div>
                  <div className="regular">{project.title_long}</div>
                  <div className="project-tile-more">
                    <div>See more</div>
                    <FontAwesomeIcon icon={faArrowRight} />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="flex-col gap-2">
          {projects.map((project) => (
            <Link to={`/project/${project.id}`} className="mobileView" key={project.id}>
              <div className="project-title-mobile">{project.title_short}</div>
              <div className="projectImageWrapper">
                {project.overlay && (<div className="img-overlay">{project.overlay}</div>)}
                <img src={project.backgroundIMG} alt="b-img" className="projectCoverMobile" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}